import partnershipApi from "services/api/pmk/partnershipApi";
import { useGetApi, useMutateApi } from "../hooks";

export const useGetImagePartnership = ({ body, enabled, onSuccess } = {}) =>
  useGetApi({
    fetch: () => partnershipApi.getImagePartnership({ body }),
    key: ["partnershipApi.getImagePartnership", body],
    enabled,
    onSuccess
  });

export const useAddAccountPartnership = ({
  enabled,
  onSuccess,
  onError
} = {}) =>
  useMutateApi({
    fetch: partnershipApi.addAccountPartnership,
    key: ["partnershipApi.addAccountPartnership"],
    enabled,
    onSuccess,
    onError
  });

export const useGetAllAccountRolePartnership = ({
  params,
  enabled,
  onSuccess,
  onError
} = {}) =>
  useGetApi({
    fetch: () => partnershipApi.getAllAccountRolePartnership({ params }),
    key: ["partnershipApi.getAllAccountRolePartnership", params],
    enabled,
    onSuccess,
    onError
  });
